module.exports = __webpack_public_path__ + "img/gwnu_gallery2.24c118a5.jpg";